<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DEPT_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-6">
            <sui-text-field
              v-model="frame0.deptNmSearchText"
              maxlength="20"
              class="width100"
              @keyup.enter="onSearchClick"
              @keyup="onKeyUpInput"
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              type="button"
              class="comm_btn_Reset"
              @click="onResetClick"
            >
              {{ $t("MSG_BTN_RESET") }}
            </sui-button>
            <sui-button
              v-permission:read="'PGE_CMY_00051'"
              type="button"
              class="comm_btn_Scr"
              @click="onSearchClick"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_DEPT_LIST") }}</h4>
      </div>
      <div class="comm_shut_wrap">
        <div class="inbox">
          <div class="comm_gridTop_wrap">
            <div class="btn_wrapL">
              <sui-button
                type="button"
                :class="expandAll ? 'comm_btn_treeOpen' : 'comm_btn_treeClose'"
                @click="onTreeGridCollapseToggle"
              />
            </div>
            <div class="btn_wrapR">
              <sui-button
                v-permission:delete="this.$options.name"
                type="button"
                class="comm_btn_gridTop"
                @click="onDelDept"
              >
                {{ $t("MSG_BTN_DEL") }}
              </sui-button>
              <sui-button
                v-permission:create="'PGE_CMY_00051'"
                type="button"
                class="comm_btn_gridTop"
                @click="onNewDept"
              >
                {{ $t("MSG_BTN_ADD_NEW") }}
              </sui-button>
            </div>
          </div>
          <sui-tree
            ref="deptTree"
            v-bind="filteredTreeData"
            class="brdG01 pd20"
            style="height:450px; overflow:auto;"
            :editable="false"
            @item-click="onItemClick"
          />
        </div>
        <div class="btnbox" />
        <div class="inbox">
          <sui-page-tab-box-type
            ref="tab"
            :tabItems="tabItems"
            :defaultTabIndex="defaultTabIndex"
            :setCurrentTabComponent="setCurrentTabComponent"
            @change-tab-idx="onChangeTabIdx"
          >
            <container
              :is="currentTabComponent"
              :pageId="this.$options.name"
              :selectedTreeData="selectedTreeData"
              :multiLanguageId="multiLanguageId"
              @onSearchClick="onTabSearch"
              @page-deactivate="handleChildDeactivated"
              @page-activate="handleChildActivated"
            />
          </sui-page-tab-box-type>
        </div>
      </div>
      <sui-popup
        v-model="isShownPopupNew"
        :title="$t('MSG_TIT_DEPT_RGST')"
      >
        <p01
          :departmentId="frame0.departmentId"
          :departmentLevel="frame0.departmentLevel"
          @close="popNewClose"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';
import t01 from './components/PGE_CMY_00051_T01';
import p01 from './components/PGE_CMY_00051_P01';

export default {
  name: 'PGE_CMY_00051', // eslint-disable-line vue/name-property-casing
  components: {
    t01,
    p01,
  },
  extends: BasePage,
  data() {
    return {
      frame0: {},
      expandAll: false,
      isShownPopupNew: false,
      treeData: {
        data: [],
      },
      selectedTreeData: {},
      defaultTabIndex: 0,
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_DTL_CNTN'),
          component: t01,
        },
      ],
      multiLanguageId: '',
      currentTabComponent: t01,
      searchFieldOldText: '',
    };
  },

  computed: {
    filteredTreeData() {
      const filteredTreeData = {};
      const filterText = (this.frame0.deptNmSearchText || '').toLowerCase();
      const treeData = JSON.parse(JSON.stringify(this.treeData.data));

      treeData.forEach(item => {
        const descendants = this.getDescendantDepts(item);
        descendants.forEach(descendant => {
          const isMatched = descendant.text.toLowerCase().indexOf(filterText) > -1;
          if (!isMatched) {
            const descendantDescendants = this.getDescendantDepts(descendant);
            const isDescendantMatched = descendantDescendants.some(descendantDescendant => descendantDescendant.text.toLowerCase().indexOf(filterText) > -1);
            if (!isDescendantMatched) {
              descendant.isInvalid = true;
            }
          }
        });
        const isMatched = item.text.toLowerCase().indexOf(filterText) > -1;
        if (!isMatched) {
          const isDescendantMatched = descendants.some(descendant => descendant.text.toLowerCase().indexOf(filterText) > -1);
          if (!isDescendantMatched) {
            item.isInvalid = true;
          }
        }
      });

      filteredTreeData.data = treeData;
      return filteredTreeData;
    },
  },

  mounted() {
    this.onSearchClick();
  },

  methods: {
    onSearchClick(selectedDeptId) {
      const thisVue = this;

      http.request(this.$options.name, 'DTS_CMY_00009', {
      }).then(res => {
        this.setTreeData(res.data);
        if (selectedDeptId && typeof (selectedDeptId) === 'string') {
          thisVue.$refs.deptTree.$nextTick(() => {
            thisVue.$refs.deptTree.select(selectedDeptId);
            thisVue.$refs.deptTree.$emit('item-click', thisVue.$refs.deptTree.getTreeItemById(selectedDeptId));
          });
        }
      }).catch(error => {
        console.log(error);
      });
    },
    setTreeData(data) {
      const rootNode = utils.getMakeTreeData({
        id: 'departmentId',
        parentId: 'upDepartmentId',
        level: 'departmentLevel',
        value: 'departmentName',
        text: '{{departmentName}}',
      }, data, true);

      this.treeData = { data: rootNode };
    },
    getDescendantDepts(node) {
      const thisVue = this;
      const descendants = [];

      if (node != null) {
        if (node.children.length > 0) {
          node.children.forEach(child => {
            descendants.push(child);
            const descendantChildren = thisVue.getDescendantDepts(child);
            descendantChildren.forEach(descendantChild => {
              descendants.push(descendantChild);
            });
          });
        }
      }

      return descendants;
    },
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    onResetClick() {
      this.frame0.deptNmSearchText = '';
    },
    onItemClick(node) {
      this.selectedTreeData = node.data;
    },
    onTreeGridCollapseToggle() {
      if (this.expandAll) {
        this.onClickExpand();
      } else {
        this.onClickCollapse();
      }
      this.expandAll = !this.expandAll;
    },
    onClickExpand() {
      this.treeData.data.forEach(child => {
        child.opened = true;
      });
    },
    onClickCollapse() {
      this.treeData.data.forEach(child => {
        // eslint-disable-next-line no-param-reassign
        child.opened = false;
      });
    },
    onDelDept() {
      if (this.$refs.deptTree.getSelection().length === 0) {
        // utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
        utils.messageBox('alert', null, this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return;
      }

      const deleteDeptIds = this.getDescendantDepts(this.$refs.deptTree.getSelection()[0]).map(descendant => descendant.departmentId);
      deleteDeptIds.unshift(this.$refs.deptTree.getSelection()[0].departmentId);

      utils.messageBox('confirm', this.$t('MSG_ALT_IS_DEL_DATA'), null, () => {
        http.request(this.$options.name, 'DTS_CMY_00094', {
          data: deleteDeptIds,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DEL_DATA'), null, this.onSearchClick);
          const deleteData = {
            data: {
              departmentId: '',
              departmentName: '',
              departmentEnglishName: '',
              departmentLevel: '',
              departmentOrder: '',
              infoUseYn: '',
            },
          };
          this.onItemClick(deleteData);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    onNewDept() {
      const deptIdLength = this.$refs.deptTree.getSelection().length;

      if (deptIdLength === 0) {
        this.frame0.departmentId = '';
        this.frame0.departmentLevel = '';
      } else if (deptIdLength > 0) {
        this.frame0.departmentId = this.$refs.deptTree.getSelection()[0].departmentId;
        this.frame0.departmentLevel = utils.toCharNum(this.$refs.deptTree.getSelection()[0].departmentLevel);
      }

      this.isShownPopupNew = !this.isShownPopupNew;
    },
    onTabSearch(selectedDeptId) {
      this.onSearchClick(selectedDeptId);
    },
    popNewClose(newDeptId) {
      this.isShownPopupNew = !this.isShownPopupNew;
      this.onSearchClick(newDeptId);
    },
    onKeyUpInput() {
      const searchFieldNewText = this.frame0.deptNmSearchText;

      if (utils.isEmpty(searchFieldNewText) === false) {
        if (utils.isExistSpecialChar(searchFieldNewText) === true) {
          this.conFirm('error', this.$t('MSG_ALT_NO_SPECL_CHAR'), null);
          this.frame0.deptNmSearchText = this.searchFieldOldText;
        } else {
          this.searchFieldOldText = searchFieldNewText;
        }
      }
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
  },
};
</script>
<style scoped>
</style>
